import apiAxios from '../../services/axios/axiosConfig';

async function login(data: {
  email: string;
  password: string;
}) {
  const response = await apiAxios.post<void>('/api/v1/login', data, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}

export default login;
